module.exports = __webpack_public_path__ + "static/media/chatroom.c19a5217.PNG";